export enum QuestionsOptionsEnum {
  YES = 'yes',
  NO = 'no',
  NOT_AT_ALL_SATISFIED = 'notAtAllSatisfied',
  PARTIALLY_SATISFIED = 'partiallySatisfied',
  MOSTLY_SATISFIED = 'mostlySatisfied',
  SATISFIED = 'satisfied',
  COMPLETELY_SATISFIED = 'completelySatisfied',
}
